"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var date_fns_1 = require("date-fns");
var regex_1 = require("./regex");
var composeValidators = function () {
    var validators = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        validators[_i] = arguments[_i];
    }
    return function (value) {
        return validators.reduce(function (error, validator) { return error || validator(value); }, undefined);
    };
};
exports.composeValidators = composeValidators;
var dateValidator = function (value) {
    if (Object.prototype.toString.call(value) === '[object Date]') {
        if (isNaN(value.getTime())) {
            return 'Invalid Date';
        }
        else {
            return undefined;
        }
    }
    else {
        return 'Invalid Date';
    }
};
exports.dateValidator = dateValidator;
var emailValidator = function (value) {
    if (value === '') {
        return undefined;
    }
    return regex_1.emailRegex.test(value) ? undefined : 'Not a valid email';
};
exports.emailValidator = emailValidator;
var honeypotValidator = function (value) {
    return !value ? undefined : ' ';
};
exports.honeypotValidator = honeypotValidator;
var minLengthValidator = function (minOptions) { return function (value) {
    var minLength = minOptions.minLength, customMessage = minOptions.customMessage;
    var msg = customMessage ? customMessage : "Field must have " + minLength + " characters.";
    return value.length >= minLength ? undefined : msg;
}; };
exports.minLengthValidator = minLengthValidator;
var isSameDay = function (d1, d2) {
    return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
};
var notPastDateValidator = function (value) {
    if (Object.prototype.toString.call(value) === '[object Date]') {
        if (isNaN(value.getTime())) {
            return 'Invalid Date';
        }
        else {
            if (isSameDay(new Date(), value) || date_fns_1.compareAsc(value, new Date()) === 1) {
                return undefined;
            }
            else {
                return 'Date cannot be in the past.';
            }
        }
    }
    else {
        return 'Invalid Date';
    }
};
exports.notPastDateValidator = notPastDateValidator;
var regexValidator = function (regexOptions) { return function (value) {
    var regex = regexOptions.regex, message = regexOptions.message;
    return regex.test(value) ? undefined : message;
}; };
exports.regexValidator = regexValidator;
var requiredValidator = function (value) {
    return value ? undefined : 'Required';
};
exports.requiredValidator = requiredValidator;
var zipValidator = function (value) {
    if (value === '') {
        return undefined;
    }
    return regex_1.zipRegex.test(value) ? undefined : 'Not a valid zip code';
};
exports.zipValidator = zipValidator;
